import {initializeSelect2} from "../../helpers/select2_helper";

document.addEventListener('DOMContentLoaded', () => {
  if ($('#facebook-applications-edit, #facebook-applications-new').length > 0) {
    initializeSelect2('#facebook_application_page_ids', true)
  }
})
